jQuery(document).ready(function($)
{
	var breakpoint_medium = 640;

	// Attributen die WooCommerce's eigen productvariatie-wissel-JS (add-to-cart-variation.js,
	// functie wc_variations_image_update) muteert op de eerste galerij-afbeelding zodra een
	// variatie met een eigen foto gekozen wordt - nodig om die wissel op mobiel weer ongedaan
	// te kunnen maken, zie nw_remember_product_gallery_original_image / nw_restore_...
	var NW_GALLERY_VARIATION_SWAP_ATTRS = ['src', 'srcset', 'sizes', 'width', 'height', 'title', 'alt', 'data-caption', 'data-src', 'data-large_image', 'data-large_image_width', 'data-large_image_height'];

	/////////////////////////////////////////////////////////////////////////////////////////////////
	//										PRODUCT GALLERY
	/////////////////////////////////////////////////////////////////////////////////////////////////
	// Positie (links/onder) en de actieve-afbeelding-markup komen server-side van
	// inc/product-gallery.php. Hier: een losse thumb-rail bouwen (vaste set knoppen die
	// nooit van plek wisselen, net als bij Zalando), klik-om-te-wisselen, en de bestaande
	// lightbox-popup scopen tot alleen de hoofdfoto op desktop. Op mobiel wordt de
	// hoofdfoto een swipe-slider (CSS scroll-snap in _woocommerce.scss) en blijven de
	// rail en de lightbox uit.
	//
	// De originele .woocommerce-product-gallery__image elementen worden nooit verplaatst -
	// alleen de nw-gallery-image--active class schuift van element naar element. Zo blijft
	// WooCommerce's eigen productvariatie-wissel-JS (add-to-cart-variation.js, muteert
	// altijd .eq(0)) gewoon werken.

	if ($('.woocommerce-product-gallery').length > 0)
	{
		var nw_gallery_desktop_query = window.matchMedia('(min-width: ' + breakpoint_medium + 'px)');

		$('.woocommerce-product-gallery').each(function()
		{
			nw_init_product_gallery($(this), nw_gallery_desktop_query.matches);
		});

		nw_gallery_desktop_query.addEventListener('change', function(event)
		{
			$('.woocommerce-product-gallery').each(function()
			{
				nw_set_product_gallery_lightbox($(this), event.matches);
			});
		});

		// WooCommerce roept dit aan (add-to-cart-variation.js) nadat een productvariatie
		// de hoofdfoto heeft vervangen, of nadat de hele galerij is her-gerenderd
		$(document).on('woocommerce_gallery_init_zoom wc-product-gallery-after-init', '.images', function()
		{
			$(this).find('.woocommerce-product-gallery').each(function()
			{
				nw_init_product_gallery($(this), nw_gallery_desktop_query.matches);
			});
		});

		// Bij "Links" volgt de rail-hoogte de weergegeven hoogte van de hoofdfoto (zie
		// _woocommerce.scss) - die kan bij een resize veranderen, dus de pijl-zichtbaarheid
		// moet dan opnieuw bepaald worden
		$(window).on('resize', function()
		{
			$('.nw-gallery-rail').each(function()
			{
				var $rail  = $(this);
				var $track = $rail.find('> .nw-gallery-rail-track');

				nw_update_product_gallery_rail_arrows($rail, $track);
			});
		});

		// WooCommerce's eigen productvariatie-wissel (add-to-cart-variation.js) muteert ALTIJD de
		// eerste galerij-afbeelding (.woocommerce-product-gallery__image:eq(0)). In onze opzet
		// verschuift alleen de nw-gallery-image--active class van element naar element; de
		// DOM-volgorde blijft gelijk. Zolang #0 actief is werkt WC's wissel gewoon zichtbaar, maar
		// zodra de bezoeker tussendoor een thumb heeft aangeklikt staat de actieve class op een
		// ander element en is #0 verborgen (display:none) - WC's update landt dan op een
		// onzichtbare afbeelding. Deze handlers herstellen dat.
		$(document).on('found_variation', '.variations_form', function(event, variation)
		{
			nw_apply_product_gallery_variation($(this), variation);
		});

		// "Wissen"/reset: WC zet #0 terug op de originele foto - maak #0 dan ook weer actief
		$(document).on('reset_data', '.variations_form', function()
		{
			nw_apply_product_gallery_variation($(this), null);
		});
	}

	/**
	 * Houdt de zichtbare hoofdfoto in sync met een gekozen (of gewiste) productvariatie.
	 *
	 * Op desktop: zorgt dat na WC's variatie-wissel de juiste galerij-afbeelding de actieve
	 * (zichtbare) is - de bijpassende thumb als de variatie-foto er een is (rail-highlight loopt
	 * mee), anders afbeelding #0 die WC net heeft bijgewerkt/hersteld.
	 * Op mobiel: de hoofdfoto wisselt niet mee (zie nw_restore_product_gallery_original_image) -
	 * in plaats daarvan wordt naar de bijpassende swipe-slide gescrold als die bestaat.
	 *
	 * @param {jQuery}      $form     Het .variations_form element.
	 * @param {Object|null} variation De variatiedata van WooCommerce, of null bij een reset.
	 *
	 * @return {void}
	 */
	function nw_apply_product_gallery_variation($form, variation)
	{
		var $gallery = $form.closest('.product').find('.woocommerce-product-gallery').first();
		var $wrapper = $gallery.find('> .woocommerce-product-gallery__wrapper');
		var $images  = $wrapper.find('> .woocommerce-product-gallery__image');

		if ($images.length <= 1)
		{
			return;
		}

		var image_id = (variation && variation.image_id) ? String(variation.image_id) : '';
		var $match   = image_id ? $images.filter('[data-attachment-id="' + image_id + '"]') : $();

		if (!nw_gallery_desktop_query.matches)
		{
			// MOBIEL. Geen scrollIntoView() - die scrollt ook verticale voorouders (de pagina zelf)
			// mee. Alleen de horizontale scrollLeft van de wrapper zelf zetten. scrollTo met
			// behavior:'smooth' is snap-aware, in tegenstelling tot jQuery's .animate({scrollLeft}).
			if ($match.length > 0)
			{
				var wrapper_rect = $wrapper[0].getBoundingClientRect();
				var match_rect   = $match[0].getBoundingClientRect();

				$wrapper[0].scrollTo({ left: $wrapper.scrollLeft() + (match_rect.left - wrapper_rect.left), behavior: 'smooth' });
			}

			return;
		}

		// DESKTOP. Bij een reset_data tijdens de pagina-init kan de rail nog niet gebouwd zijn -
		// dan is er ook nog niets stuk en kunnen we gewoon wachten op nw_init_product_gallery.
		var $rail = $wrapper.find('> .nw-gallery-rail');

		if ($rail.length === 0 || !$images.eq(0).data('nw-gallery-control'))
		{
			return;
		}

		if ($match.length > 0)
		{
			var $target = $match.first();

			nw_activate_product_gallery_image($wrapper, $rail, $target);

			// #0 zet WC zelf al op de juiste (variatie-)bron; alleen 2e+ afbeeldingen staan nog op
			// de kleine rail-maat en moeten naar hun volledige bron
			if (!$target.is($images.eq(0)))
			{
				nw_upgrade_product_gallery_image_src($target);
			}
		}
		else
		{
			// Losse variatie-foto of reset: WC heeft #0 bijgewerkt/hersteld - maak #0 weer actief
			nw_activate_product_gallery_image($wrapper, $rail, $images.eq(0));
		}
	}

	function nw_init_product_gallery($gallery, is_desktop)
	{
		var $wrapper = $gallery.find('> .woocommerce-product-gallery__wrapper');
		var $images  = $wrapper.find('> .woocommerce-product-gallery__image');

		nw_remember_product_gallery_original_image($images.eq(0));

		if ($images.length > 1)
		{
			var $rail = nw_build_product_gallery_rail($wrapper, $images);

			// Ook bij een her-init (na productvariatie-wissel) altijd terug naar de eerste
			// afbeelding - WooCommerce heeft die net met de variatie-foto overschreven
			nw_activate_product_gallery_image($wrapper, $rail, $images.eq(0));

			// Positie-indicator voor de mobiele swipe-galerij (op desktop door CSS verborgen)
			nw_build_product_gallery_mobile_pager($gallery, $wrapper, $images);

			if (is_desktop)
			{
				// Warm de volledige foto's alvast in de cache zodat een thumb-klik niet flitst -
				// alleen op desktop (daar swapt de klik naar de grote bron); op mobiel zou dit
				// onnodig mobiele data kosten en regelt srcset het al bij het swipen
				nw_preload_product_gallery_full_images($gallery, $images);
			}
		}

		if (!is_desktop)
		{
			// Op mobiel is er geen "hoofdfoto"-slot om te wisselen - alle foto's staan
			// gelijkwaardig naast elkaar in de swipe-strip. WooCommerce's eigen
			// productvariatie-wissel-JS muteert desondanks altijd de eerste afbeelding, wat op
			// mobiel een willekeurige slide in de scroll-lijst zou laten veranderen zonder dat de
			// gebruiker dat door heeft. Zet 'm terug naar zijn eigen, originele foto.
			nw_restore_product_gallery_original_image($images.eq(0));
		}

		nw_set_product_gallery_lightbox($gallery, is_desktop);
	}

	function nw_remember_product_gallery_original_image($image)
	{
		var $img = $image.find('img').first();

		if ($img.data('nw-original-attrs'))
		{
			return;
		}

		var original = {};

		$.each(NW_GALLERY_VARIATION_SWAP_ATTRS, function(index, name)
		{
			original[name] = $img.attr(name);
		});

		$img.data('nw-original-attrs', original);

		var $link = $image.find('a').first();
		$link.data('nw-original-href', $link.attr('href'));
	}

	function nw_restore_product_gallery_original_image($image)
	{
		var $img     = $image.find('img').first();
		var original = $img.data('nw-original-attrs');

		if (!original)
		{
			return;
		}

		$.each(original, function(name, value)
		{
			if (typeof value === 'undefined')
			{
				$img.removeAttr(name);
			}
			else
			{
				$img.attr(name, value);
			}
		});

		var $link          = $image.find('a').first();
		var original_href  = $link.data('nw-original-href');

		if (typeof original_href !== 'undefined')
		{
			$link.attr('href', original_href);
		}
	}

	function nw_build_product_gallery_rail($wrapper, $images)
	{
		var $rail = $wrapper.find('> .nw-gallery-rail');

		if ($rail.length === 0)
		{
			$rail = $('<div class="nw-gallery-rail"></div>').appendTo($wrapper);
		}

		$rail.empty();

		// De track is het element dat daadwerkelijk scrollt. Los van .nw-gallery-rail zelf
		// gehouden, want die laatste is het (niet-scrollende) anker voor de pijlen hieronder -
		// position:absolute pijlen als kind van het scrollende element zouden gewoon meescrollen
		// met de inhoud in plaats van vast te blijven staan.
		var $track = $('<div class="nw-gallery-rail-track"></div>').appendTo($rail);

		$images.each(function()
		{
			var $image     = $(this);
			// data-rail-thumb (altijd ongecropt) i.p.v. data-thumb: dat laatste wijst op
			// WooCommerce's eigen gallery_thumbnail-maat, die hard gecropt is zodra de shop niet
			// voor "Niet-bijgesneden" kiest bij Thumbnail cropping - de rail moet altijd de hele
			// foto tonen, alleen geschaald
			var $thumb_img = $('<img>').attr('src', $image.attr('data-rail-thumb') || $image.attr('data-thumb')).attr('alt', $image.attr('data-thumb-alt') || '');
			var $control   = $('<button type="button" class="nw-gallery-thumb"></button>').append($thumb_img);

			$image.data('nw-gallery-control', $control);

			$control.on('click', function()
			{
				nw_activate_product_gallery_image($wrapper, $rail, $image);

				// Afbeeldingen 2+ zijn door WooCommerce alleen op de kleine gallery_thumbnail-maat
				// gerenderd (bedoeld voor de rail) - pas nu, bij een echte klik, opschalen naar de
				// volledige foto (data-src, dezelfde bron die de lightbox ook gebruikt) zodat 'm
				// niet wazig wordt uitgerekt op de hoofdfoto-positie. Niet bij elke init/reset doen,
				// anders wordt bij elk paginabezoek onnodig een extra download getriggerd
				nw_upgrade_product_gallery_image_src($image);
			});

			$track.append($control);
		});

		nw_build_product_gallery_rail_arrows($rail, $track);

		return $rail;
	}

	function nw_build_product_gallery_rail_arrows($rail, $track)
	{
		var $prev = $('<button type="button" class="nw-gallery-rail-arrow nw-gallery-rail-arrow--prev" aria-label="Vorige"><span></span></button>');
		var $next = $('<button type="button" class="nw-gallery-rail-arrow nw-gallery-rail-arrow--next" aria-label="Volgende"><span></span></button>');

		$prev.on('click', function()
		{
			nw_scroll_product_gallery_rail($track, -1);
		});

		$next.on('click', function()
		{
			nw_scroll_product_gallery_rail($track, 1);
		});

		$rail.append($prev).append($next);

		$track.off('scroll.nwGalleryRail').on('scroll.nwGalleryRail', function()
		{
			nw_update_product_gallery_rail_arrows($rail, $track);
		});

		// Muiswiel over de rail scrollt de rail zelf - zo hoef je de kleine chevrons niet te
		// raken om door de thumbs te bladeren. De enige as die een gewone muis levert (deltaY)
		// wordt naar de scrollrichting van de rail vertaald (verticaal bij "Links", horizontaal
		// bij "Onder").
		$track.off('wheel.nwGalleryRail').on('wheel.nwGalleryRail', function(event)
		{
			nw_wheel_scroll_product_gallery_rail($track, event);
		});

		nw_update_product_gallery_rail_arrows($rail, $track);
	}

	/**
	 * Vertaalt een muiswiel-event boven de rail naar een scroll van de rail-track.
	 *
	 * Onderdrukt de normale pagina-scroll alleen zolang de rail in de gevraagde richting zelf
	 * nog kan scrollen - aan het begin/eind van de rail neemt de pagina het wiel gewoon over,
	 * zodat de gebruiker niet "vast" komt te zitten boven de thumbnails.
	 *
	 * @param {jQuery} $track      De scrollende .nw-gallery-rail-track.
	 * @param {jQuery.Event} event Het jQuery wheel-event.
	 *
	 * @return {void}
	 */
	function nw_wheel_scroll_product_gallery_rail($track, event)
	{
		var track       = $track[0];
		var is_vertical = $track.closest('.nw-gallery-position-left').length > 0;
		var delta       = event.originalEvent ? event.originalEvent.deltaY : 0;

		if (!delta)
		{
			return;
		}

		var pos      = is_vertical ? track.scrollTop : track.scrollLeft;
		var max      = is_vertical
			? track.scrollHeight - track.clientHeight
			: track.scrollWidth - track.clientWidth;
		var at_start = pos <= 0;
		var at_end   = pos >= max - 1;

		if ((delta < 0 && at_start) || (delta > 0 && at_end))
		{
			return;
		}

		event.preventDefault();

		if (is_vertical)
		{
			track.scrollBy({ top: delta });
		}
		else
		{
			track.scrollBy({ left: delta });
		}
	}

	function nw_scroll_product_gallery_rail($track, direction)
	{
		var track       = $track[0];
		var is_vertical = $track.closest('.nw-gallery-position-left').length > 0;

		// Eén "pagina" (de zichtbare lengte van de rail) per klik. Native scrollBy met
		// behavior:'smooth' i.p.v. jQuery's .animate({scrollLeft/scrollTop}): die laatste zet de
		// scrollpositie stapsgewijs handmatig, wat vecht met de CSS scroll-snap-type op de track
		// (de browser springt er tussen de stappen door telkens naar het dichtstbijzijnde
		// snap-punt) - vandaar dat het nu in één ruk naar het einde lijkt te schieten. scrollBy
		// is wel snap-aware en scrollt daardoor soepel door naar het juiste snap-punt. Zelfde
		// aanpak als de found_variation-handler hierboven.
		var step = is_vertical ? track.clientHeight : track.clientWidth;

		if (is_vertical)
		{
			track.scrollBy({ top: direction * step, behavior: 'smooth' });
		}
		else
		{
			track.scrollBy({ left: direction * step, behavior: 'smooth' });
		}
	}

	function nw_update_product_gallery_rail_arrows($rail, $track)
	{
		var is_vertical  = $track.closest('.nw-gallery-position-left').length > 0;
		var scroll_pos   = is_vertical ? $track.scrollTop() : $track.scrollLeft();
		var scroll_size  = is_vertical ? $track[0].scrollHeight : $track[0].scrollWidth;
		var client_size  = is_vertical ? $track.height() : $track.width();
		var can_scroll   = scroll_size > client_size + 1;
		var at_start     = scroll_pos <= 1;
		var at_end       = scroll_pos >= scroll_size - client_size - 1;

		$rail.find('.nw-gallery-rail-arrow--prev').toggleClass('is-hidden', !can_scroll || at_start);
		$rail.find('.nw-gallery-rail-arrow--next').toggleClass('is-hidden', !can_scroll || at_end);

		// _woocommerce.scss gebruikt deze classes voor de rand-fade ("er is meer om te scrollen"),
		// alleen aan de kant waar nog verborgen thumbs zitten
		$rail.toggleClass('nw-gallery-rail--can-scroll-start', can_scroll && !at_start);
		$rail.toggleClass('nw-gallery-rail--can-scroll-end', can_scroll && !at_end);
	}

	function nw_activate_product_gallery_image($wrapper, $rail, $image)
	{
		$wrapper.find('> .woocommerce-product-gallery__image').removeClass('nw-gallery-image--active').addClass('nw-gallery-image--thumb').removeAttr('aria-current');
		$image.removeClass('nw-gallery-image--thumb').addClass('nw-gallery-image--active').attr('aria-current', 'true');

		var $control = $image.data('nw-gallery-control');

		$rail.find('.nw-gallery-thumb').removeClass('is-active').removeAttr('aria-current');
		$control.addClass('is-active').attr('aria-current', 'true');

		nw_scroll_product_gallery_thumb_into_view($rail, $control);
	}

	/**
	 * Scrollt de rail zo dat de opgegeven thumb-knop volledig in beeld staat.
	 *
	 * Nodig omdat je op een thumb kunt klikken die aan de scrollrand maar half zichtbaar is, en
	 * omdat een productvariatie-wissel de galerij terugzet op de eerste afbeelding terwijl de
	 * rail nog elders staat - zonder dit blijft de actieve thumb dan (deels) buiten beeld.
	 *
	 * @param {jQuery} $rail    De .nw-gallery-rail wrapper.
	 * @param {jQuery} $control De nu actieve .nw-gallery-thumb knop.
	 *
	 * @return {void}
	 */
	function nw_scroll_product_gallery_thumb_into_view($rail, $control)
	{
		if (!$control || $control.length === 0)
		{
			return;
		}

		var $track = $rail.find('> .nw-gallery-rail-track');

		if ($track.length === 0)
		{
			return;
		}

		var track        = $track[0];
		var control      = $control[0];
		var is_vertical  = $rail.closest('.nw-gallery-position-left').length > 0;
		var track_rect   = track.getBoundingClientRect();
		var control_rect = control.getBoundingClientRect();
		var before       = is_vertical ? control_rect.top - track_rect.top : control_rect.left - track_rect.left;
		var after        = is_vertical ? control_rect.bottom - track_rect.bottom : control_rect.right - track_rect.right;
		var shift        = 0;

		if (before < 0)
		{
			shift = before;
		}
		else if (after > 0)
		{
			shift = after;
		}

		// Kleine sub-pixel-verschillen negeren - anders triggert elke activatie een minuscule scroll
		if (Math.abs(shift) <= 1)
		{
			return;
		}

		if (is_vertical)
		{
			track.scrollBy({ top: shift, behavior: 'smooth' });
		}
		else
		{
			track.scrollBy({ left: shift, behavior: 'smooth' });
		}
	}

	/**
	 * Bouwt de mobiele positie-indicator (dots + "n / totaal"-teller) voor de swipe-galerij.
	 *
	 * Op mobiel is elke foto een volle-breedte slide in een horizontale scroll-strip (zie
	 * _woocommerce.scss). Zonder indicator zie je niet hoeveel foto's er zijn of waar je bent -
	 * het dunne scrollbalkje is te subtiel en niet permanent zichtbaar. Dots bij een handvol
	 * foto's, plus altijd een teller die ook bij veel foto's compact blijft. Op desktop verbergt
	 * CSS het geheel; het element wordt daar wel gebouwd (net als de rail) voor het geval de
	 * viewport later naar mobiel formaat gaat.
	 *
	 * @param {jQuery} $gallery De .woocommerce-product-gallery.
	 * @param {jQuery} $wrapper De scrollende .woocommerce-product-gallery__wrapper.
	 * @param {jQuery} $images  De .woocommerce-product-gallery__image slides.
	 *
	 * @return {void}
	 */
	function nw_build_product_gallery_mobile_pager($gallery, $wrapper, $images)
	{
		var total = $images.length;

		// Idempotent: bij een her-init (na productvariatie-wissel) eerst de oude weghalen
		$gallery.find('> .nw-gallery-pager').remove();

		var $pager = $('<div class="nw-gallery-pager"></div>');

		// Bij veel foto's worden losse dots een onleesbare kluwen - dan enkel de teller tonen
		if (total <= 8)
		{
			var $dots = $('<div class="nw-gallery-pager-dots"></div>');

			$images.each(function(index)
			{
				var $dot = $('<button type="button" class="nw-gallery-pager-dot" aria-label="Ga naar afbeelding ' + (index + 1) + '"></button>');

				$dot.on('click', function()
				{
					nw_scroll_product_gallery_to_slide($wrapper, index);
				});

				$dots.append($dot);
			});

			$pager.append($dots);
		}

		$pager.append($('<span class="nw-gallery-pager-count"></span>'));
		$gallery.append($pager);

		nw_update_product_gallery_pager($pager, total, 0);

		$wrapper.off('scroll.nwGalleryPager').on('scroll.nwGalleryPager', function()
		{
			nw_schedule_product_gallery_pager_update($wrapper, $pager, total);
		});
	}

	/**
	 * Werkt de pager bij op de eerstvolgende frame (rAF-guard tegen scroll-event-storm).
	 *
	 * @param {jQuery} $wrapper De scrollende wrapper.
	 * @param {jQuery} $pager   Het .nw-gallery-pager element.
	 * @param {number} total    Aantal slides.
	 *
	 * @return {void}
	 */
	function nw_schedule_product_gallery_pager_update($wrapper, $pager, total)
	{
		if ($wrapper.data('nw-pager-raf'))
		{
			return;
		}

		$wrapper.data('nw-pager-raf', true);

		window.requestAnimationFrame(function()
		{
			$wrapper.data('nw-pager-raf', false);

			var slide_width = $wrapper[0].clientWidth;
			var index       = slide_width > 0 ? Math.round($wrapper[0].scrollLeft / slide_width) : 0;

			nw_update_product_gallery_pager($pager, total, index);
		});
	}

	/**
	 * Zet de actieve dot en de tellertekst op de gegeven slide-index.
	 *
	 * @param {jQuery} $pager Het .nw-gallery-pager element.
	 * @param {number} total  Aantal slides.
	 * @param {number} index  Nulgebaseerde index van de zichtbare slide.
	 *
	 * @return {void}
	 */
	function nw_update_product_gallery_pager($pager, total, index)
	{
		index = Math.max(0, Math.min(index, total - 1));

		$pager.find('.nw-gallery-pager-dot').each(function(dot_index)
		{
			$(this).toggleClass('is-active', dot_index === index);
		});

		$pager.find('.nw-gallery-pager-count').text((index + 1) + ' / ' + total);
	}

	/**
	 * Scrollt de mobiele swipe-galerij soepel naar een specifieke slide.
	 *
	 * @param {jQuery} $wrapper De scrollende wrapper.
	 * @param {number} index    Nulgebaseerde slide-index.
	 *
	 * @return {void}
	 */
	function nw_scroll_product_gallery_to_slide($wrapper, index)
	{
		$wrapper[0].scrollTo({ left: $wrapper[0].clientWidth * index, behavior: 'smooth' });
	}

	function nw_upgrade_product_gallery_image_src($image)
	{
		var $img     = $image.find('img').first();
		var full_src = $img.attr('data-src');

		if (!full_src || $img.attr('src') === full_src)
		{
			return;
		}

		$img.attr('src', full_src);
		$img.removeAttr('srcset');
		$img.removeAttr('sizes');
	}

	/**
	 * Warmt de browsercache met de volledige (grote) foto van elke rail-thumbnail, zodra de rest
	 * van de pagina er staat.
	 *
	 * Afbeeldingen 2+ staan alleen op de kleine gallery_thumbnail-maat in de DOM; pas bij een
	 * thumb-klik schaalt nw_upgrade_product_gallery_image_src ze op naar data-src (de volledige
	 * foto). Zonder deze preload moet de browser die grote foto op dat moment nog ophalen - een
	 * zichtbare flits op de hoofdfoto-positie. Hier laden we ze vooruit, serieel en met lage
	 * prioriteit, zodat de preload geen bandbreedte wegneemt van wat de bezoeker direct ziet.
	 *
	 * @param {jQuery} $gallery De .woocommerce-product-gallery (draagt de eenmalig-vlag).
	 * @param {jQuery} $images  De .woocommerce-product-gallery__image slides.
	 *
	 * @return {void}
	 */
	function nw_preload_product_gallery_full_images($gallery, $images)
	{
		if ($gallery.data('nw-full-preloaded'))
		{
			return;
		}

		$gallery.data('nw-full-preloaded', true);

		// Afbeelding 1 staat al groot in beeld; alleen 2 t/m n hoeven voorgeladen
		var sources = [];

		$images.each(function(index)
		{
			if (index === 0)
			{
				return;
			}

			var $img = $(this).find('img').first();
			var src  = $img.attr('data-src') || $img.attr('data-large_image');

			if (src)
			{
				sources.push(src);
			}
		});

		if (sources.length === 0)
		{
			return;
		}

		nw_run_product_gallery_task_when_idle(function()
		{
			nw_preload_product_gallery_image_queue(sources, 0);
		});
	}

	/**
	 * Voert een taak uit zodra de browser rustig is (na window load), met nette fallbacks.
	 *
	 * @param {Function} task Uit te voeren callback.
	 *
	 * @return {void}
	 */
	function nw_run_product_gallery_task_when_idle(task)
	{
		function schedule()
		{
			if (typeof window.requestIdleCallback === 'function')
			{
				window.requestIdleCallback(task, { timeout: 2000 });
			}
			else
			{
				window.setTimeout(task, 500);
			}
		}

		if (document.readyState === 'complete')
		{
			schedule();
		}
		else
		{
			$(window).one('load', schedule);
		}
	}

	/**
	 * Laadt een lijst afbeeldings-URLs een voor een in de browsercache (geen DOM-mutatie).
	 *
	 * Serieel i.p.v. tegelijk: de preload mag nooit voorrang nemen op resources die de bezoeker
	 * wel meteen ziet.
	 *
	 * @param {string[]} sources Afbeeldings-URLs.
	 * @param {number}   index   Huidige index.
	 *
	 * @return {void}
	 */
	function nw_preload_product_gallery_image_queue(sources, index)
	{
		if (index >= sources.length)
		{
			return;
		}

		var loader = new Image();

		function next()
		{
			nw_preload_product_gallery_image_queue(sources, index + 1);
		}

		loader.onload        = next;
		loader.onerror       = next;
		loader.decoding      = 'async';
		loader.fetchPriority = 'low';
		loader.src           = sources[index];
	}

	function nw_set_product_gallery_lightbox($gallery, is_desktop)
	{
		var $wrapper = $gallery.find('> .woocommerce-product-gallery__wrapper');

		$wrapper.unslickLightbox();
		$wrapper.off('click.nwGalleryMobile');

		if (!is_desktop)
		{
			// De <a> blijft bestaan (WooCommerce's variatie-wissel-JS zoekt en muteert 'm
			// rechtstreeks) maar mag niet naar de losse afbeeldings-URL navigeren
			$wrapper.on('click.nwGalleryMobile', '.woocommerce-product-gallery__image > a', function(event)
			{
				event.preventDefault();
			});

			return;
		}

		// De rail bestaat uit losse <button>-knoppen (geen <a>'s), dus die kunnen deze
		// direct-child selector nooit matchen - een thumb-klik opent hierdoor nooit de lightbox
		$wrapper.slickLightbox({
			itemSelector:	'> div.woocommerce-product-gallery__image > a',
			caption:		function (element, info) {
				return $(element).find('img').attr('data-caption');
			}
		});
	}
});
